import { DesignProp, GeneralProp } from "../PropCategories";

export const borderRadius = {
  prop: "style-attribute",
  name: "Border radius",
  nameI18n: "builder_ui.prop_type.styles.border_radius",
  category: [DesignProp, GeneralProp],
  type: "border-radius",
  unit: "px",
  defaultValue: {
    border_left_top_radius: "4",
    border_left_bottom_radius: "4",
    border_right_top_radius: "4",
    border_right_bottom_radius: "4",
  },
} as const;
